import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AudiencesPage } from "@/features/campaigns/AudiencesPage";

const search = z.object({
  kind: z.enum(["all", "list", "segment"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/audiences")({
  validateSearch: search,
  component: () => <AudiencesPage search={Route.useSearch()} />,
});
